import dayjs from 'dayjs'

/**
 * dayjsのユーティリティ
 *
 * dayjsはは不正値関連の入力（0, null, 空文字など）に弱いため、
 * 実装上は直接利用を避け、可能な限りはUtilを利用すること
 */

/**
 * 引数で渡された値を日時オブジェクトに変換する
 * 受け手は必ずオプショナルチェーン`?.`を利用すること
 * @param date 日時オブジェクトに変換したい元データ
 * @returns 日時オブジェクト（dayjs）
 */
const createDate = (date, format = null) => {
  if (!date) return null // 0, null, 空文字
  const dayjsObject = format ? dayjs(date, format, true) : dayjs(date)
  return dayjsObject.isValid() ? dayjsObject : null
}

/**
 * 現在時刻を返却する
 * @returns 現在日時オブジェクト（dayjs）
 */
const now = () => {
  return dayjs()
}

/**
 * 日時の差分を取得する。取得できない場合はnullを返却する。
 * @param base 基準日時オブジェクト（dayjs）
 * @param comp 比較対象日時オブジェクト（dayjs）
 * @param unit 単位（year,month,day ほか）
 * @param isFloat 浮動小数点数使用フラグ（falseの場合は切り捨てで整数返却）
 */
const dateDiff = (base, comp, unit, isFloat = false) => {
  if (!base?.isValid() || !comp?.isValid() || !unit?.length) return null
  return base.diff(comp, unit, isFloat)
}

export {
  createDate,
  now,
  dateDiff
}
